import { Badge, Box, Link, Stack, Typography } from '@mui/material'
import { useCallback, useMemo, useState } from 'react'
import FilterButton from 'components/FilterButton'
import { useQualityNumberFilters } from 'hooks/useQualityNumberFilters'
import useGetQualityNumberList from 'queries/use-get-quality-number-list'
import { getTenantId } from 'utils/token/token'
import CustomDataGrid from './DataGrid'
import SearchField from './SearchField'
import FilterDrawer from './FilterDrawer'

export default function MonitoringNumbers() {
  const [showDrawer, setShowDrawer] = useState(false)
  const tenantId = getTenantId()

  const isFilterActive = false

  const { filters } = useQualityNumberFilters()
  const { data, isLoading, isPreviousData } = useGetQualityNumberList({ ...filters, tenantId })

  const { rows = [], totalItems = 0 } = useMemo(() => {
    if (data) {
      return {
        rows: data.data,
        totalItems: data.totalRecords,
      }
    }

    return {
      rows: [],
      totalItems: 0,
    }
  }, [data])

  const toggleDrawer = useCallback(() => {
    setShowDrawer(!showDrawer)
  }, [showDrawer])

  return (
    <Stack>
      {showDrawer ? <FilterDrawer open={showDrawer} toggleDrawer={toggleDrawer} /> : null}

      <Typography
        sx={{
          fontSize: '2rem',
          fontWeight: '900',
          lineHeight: 1.5,
        }}
      >
        Monitoramento de números
      </Typography>
      <Typography variant="body2" sx={{ fontSize: '1rem', mb: '2rem' }}>
        Acompanhe a situação e qualidade dos seus números de telefone utilizados para envios de mensagens ativas (HSM) a
        cada 24 horas.
        <br />
        <Link
          color="#00AEEF"
          target="_blank"
          underline="none"
          href="https://www.facebook.com/business/help/896873687365001?locale=pt_BR"
        >
          Saiba mais sobre o funcionamento dos status e níveis de qualidade
        </Link>
      </Typography>

      <Stack sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '2rem' }}>
        <SearchField loading={isLoading} />
        <Badge
          variant="dot"
          badgeContent=" "
          color={isFilterActive ? 'error' : 'transparent'}
          sx={{ ml: 'auto', mb: '1.4rem' }}
        >
          <FilterButton handleClick={toggleDrawer} loading={isLoading} />
        </Badge>
      </Stack>

      <Box display="flex" flexDirection="column" gap="2rem" mt="2rem" paddingBottom="1rem">
        <CustomDataGrid rows={rows} loading={isLoading} total={totalItems} isPreviousData={isPreviousData} />
      </Box>
    </Stack>
  )
}
